// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { BootstrapImage, BootstrapLink } from '../../dsl/front';
import { AbstractModuleUi } from '../_abstract/ui';
import { ImageRatio } from '../_contracts';
import { LineHeader } from '../_components/ui';
import { prepareImage } from '../_filters/prepare-image';
/**
 * Component capable of rendering the `ReadMoreModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
let ReadMoreModuleUi = class ReadMoreModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        /**
         * Articles to render.
         */
        this.articles = [];
        /**
         * @inheritDoc
         */
        this.imageRatios = {
            desktop: ImageRatio.Tile,
            mobile: ImageRatio.Tile
        };
    }
    /**
     * @inheritDoc
     */
    async fetchRelated() {
        const itemsToResolve = Array.isArray(this.module.content.articles) ? this.module.content.articles : [];
        const articles = [];
        try {
            for (const item of itemsToResolve) {
                const article = await this.relatedService.resolve(item, {});
                articles.push(article);
            }
            this.articles = articles;
            this.articles.forEach(article => {
                article.thumbnail = this.getThumbnail(article);
            });
        }
        catch (e) {
            if (this.debug)
                console.warn(e);
            this.onError(e);
        }
        this.articles.length > 0 ? this.onReady() : this.onError();
    }
    /**
     * Resolves the applicable `Image` for the current screen resolution.
     */
    getThumbnail(article) {
        if (typeof article.properties.cover !== 'object' || typeof article.properties.cover === null ||
            typeof article.properties.cover.image !== 'object' || article.properties.cover.image === null) {
            return;
        }
        const maxWidth = this.isMobile ? 90 * 2 : 120 * 2;
        return prepareImage(article.properties.cover.image, this.imageRatio, maxWidth, this.module.isLazyLoaded);
    }
    /**
     * Returns the title of the given article, depending on the `titleVersion` prop.
     * @param article
     */
    getTitle(article) {
        if (!this.titleVersion) {
            return article.title;
        }
        if (typeof article.properties.additionalTitles !== 'object' || article.properties.additionalTitles === null ||
            !article.properties.additionalTitles[this.titleVersion]) {
            return article.title;
        }
        return article.properties.additionalTitles[this.titleVersion];
    }
    /**
     * TODO: Getter description.
     */
    get titleVersion() {
        return this.module.content.titleVersion;
    }
};
ReadMoreModuleUi = __decorate([
    Component({
        name: 'ReadMoreModuleUi',
        components: {
            BootstrapImage,
            BootstrapLink,
            LineHeader
        },
        async created() {
            await this.fetchRelated();
        },
        template: `
    <section class="read-more module defence-ads" :class="[debugClass, loadingClass]">

    <!-- Module header -->
    <LineHeader :showPointer="false" class="mb-0" v-if="(articles && articles.length)">
      {{ $t('_.read-more') }}
    </LineHeader>

    <ul class="list-unstyled">

      <!-- Single article -->
      <li v-for="(article, i) in articles" :key="article.urlPath + '-' + i"
          class="read-more__article position-relative border-bottom">
        <div class="row align-items-md-center">

          <!-- Article thumbnail -->
          <div v-if="module.content.showThumbnails && !!article.thumbnail" class="col-auto">
            <BootstrapImage v-bind="article.thumbnail"
                            class="read-more__article__thumbnail img-fluid"/>
          </div>

          <!-- Article title -->
          <div class="col">
            <BootstrapLink :link="{ target: article.urlPath }"
                           class="read-more__article__title stretched-link text-body fw-bold text-decoration-none h5">
              {{ getTitle(article) }}
            </BootstrapLink>
            <div v-if="article.sponsored || module.content.showSponsored" class="line-header__content text-ui-separator text-uppercase border-0 mt-1">
              {{ $t('_.sponsored') }}
            </div>
          </div>

        </div>
      </li>
      <!-- END | Single article -->

    </ul>
    </section>
  `
    })
], ReadMoreModuleUi);
export { ReadMoreModuleUi };
